import { render } from "./UnpaidEarningsWidget.vue?vue&type=template&id=4a5a6774&ts=true"
import script from "./UnpaidEarningsWidget.vue?vue&type=script&lang=ts"
export * from "./UnpaidEarningsWidget.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__